import React from "react";
import { cn } from "@/lib/utils";

/**
 * A status in a table row: a tone dot and the word (DESIGN.md §5.6). Not a filled
 * pill — when every row carries one, a column of coloured capsules is noise, and
 * "Closed" is the resting state of a bill, not news. Colour is never the only
 * signal: the word is always there (§2.4).
 *
 * Tones follow the fixed meanings: success = settled/OK · info = live work ·
 * warning = waiting on money or attention · danger = failed/voided.
 */
const statusConfig = {
  // POS
  open: { tone: "info", label: "Open" },
  kot_sent: { tone: "info", label: "KOT sent" },
  billing: { tone: "warning", label: "Billing" },
  closed: { tone: "success", label: "Closed" },
  cancelled: { tone: "danger", label: "Cancelled" },
  // Payment
  paid: { tone: "success", label: "Paid" },
  unpaid: { tone: "danger", label: "Unpaid" },
  partially_paid: { tone: "warning", label: "Partial" },
  // Table
  vacant: { tone: "neutral", label: "Vacant" },
  occupied: { tone: "info", label: "Occupied" },
  // General
  active: { tone: "success", label: "Active" },
  inactive: { tone: "neutral", label: "Inactive" },
  syncing: { tone: "info", label: "Syncing" },
};

const DOT = {
  success: "bg-success",
  info: "bg-info",
  warning: "bg-warning",
  danger: "bg-danger",
  neutral: "bg-muted-foreground",
};

export function StatusBadge({ status, className, customLabel }) {
  const config = statusConfig[status?.toLowerCase()] || { tone: "neutral", label: status || "Unknown" };
  return (
    <span className={cn("inline-flex items-center gap-1.5 text-body whitespace-nowrap", className)}>
      <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", DOT[config.tone])} aria-hidden="true" />
      {customLabel || config.label}
    </span>
  );
}
